export enum ProgradPostbackType {
    ConnectAccounts = 'connectAccounts',
    SurveyAnswered = 'surveyAnswered',
}

export interface ProgradPostback {
    postbackType: ProgradPostbackType;
    userId: string;
    productId: string;
}
